<template>
	<div id="app">
		<h1>YOU ARE ON THE USER PAGE:</h1>
		<h2>Profile</h2>
		<h2>Logged in as:</h2>
		<h2>{{ $route.params.userId }}</h2>
	</div>
</template>

<script>
export default {};
</script>